import {
    PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
    PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG,
} from '../constant';

export type Placement = 'left-start' | 'right-start';

export const getConfigPopper = (ref: Element, placement?: Placement) => {
    if (!placement) {
        placement = 'left-start';
    }
    return {
        placement: placement,
        strategy: 'absolute',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    boundary: ref,
                    rootBoundary: ref,
                    padding: PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
                },
            },
            {
                name: 'eventListeners',
                options: {
                    scroll: false,
                },
            },
        ],
    };
};
